module.exports = __webpack_public_path__ + "80a7a7b0c16ab0fe5babf33dd0e3a994.png";